import { useLike } from "../../hooks/useLike";
import { useResponsive } from "../../hooks/useResponsive";
import { BackBtn } from "../button/BackBtn";
import { IcBtnSm } from "../button/IcBtn";
import { HeaderCartBtn } from "../heading/HeaderCartBtn";
import {
  icLovedOutline,
  icLoveOutline,
  icShareOutline,
} from "../image/image-src";

export const SmProductHeader = ({ d }: { d?: ProductDetailResponse }) => {
  const responsive = useResponsive();
  if (responsive.isDesktop) return null;
  return (
    <div className="sd-bg-prod-header absolute inset-0 z-20 flex max-h-max  w-[23.4375rem] w-full flex-col p-4 sm:hidden">
      {/* h-[6.25rem] */}
      <div className="flex justify-between">
        {/* left */}
        <div className="flex">
          <BackBtn />
        </div>
        {/* right */}
        <div className="flex gap-4">
          <IcBtnSm ic={icShareOutline} />
          <TtLikeBtn id={d?.id} />
          <HeaderCartBtn />
        </div>
      </div>
    </div>
  );
};
const TtLikeBtn: React.FC<{
  id?: number;
}> = ({ id }) => {
  const { handleLike, like } = useLike(id);
  return (
    <IcBtnSm onClick={handleLike} ic={like ? icLovedOutline : icLoveOutline} />
  );
};
